import { Button, Img, Text } from "components";
import { useTranslation } from "react-i18next";
import ShareRedBox from "./ShareRedBox";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../redux/reducers/snackbar";
import globalRequest from "../../../../utils/global/globalRequest";
import { changeLoader } from "../../../../redux/reducers/loader";
import * as APIS from "../../../../utils/helper/Enum";
import { useAppFont } from "utils/helper/useAppFont";

const OrderDetailGift = ({ orderData, setIsGiftPayment }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { interClass, headingClass, interFamily} = useAppFont();

  /**
   * Resend Gift Link
   */
  const resendGiftLink = async (orderId) => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        APIS?.ORDER?.RESEND_GFT_LINK + `/${orderId}`,
        "get",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "success",
          })
        );
      } else {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "error",
          })
        );
      }
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
    dispatch(changeLoader(false));
  };

  return (
    <>
      {/* ── Gift link sent – waiting for recipient ────────────────────────── */}
      {orderData?.giftLinkToken ? (
        <div className="flex items-center justify-between gap-4 bg-red-50 border border-red-100 rounded-lg px-4 py-3 mb-4 mt-4">
          <div className="flex items-start gap-3 flex-1">
            <svg
              className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <p className={`text-sm text-gray-800 leading-relaxed ${interClass}`}>
              <span className="font-semibold text-gray-900">Please Note: </span>
              {t("yourGiftRequestHasBeenSentToTheRecipient_text")}{" "}
              {t("ifTheRecipientDoesNotGiveDetailsWithin_24_hoursTheOrderWillBeCancelled")}
            </p>
          </div>
          <button
            onClick={() => {
              try {
                resendGiftLink(orderData?.id);
                // await navigator.clipboard.writeText(
                //   "https://rabbitholeastaging.com/recipientform/" + orderData?.giftLinkToken
                // );
                // dispatch(setSnackbar({ snackbarOpen: true, snackbarMessage: "Link copied! successfully", snackbarState: "success" }));
              } catch (err) {
                // dispatch(setSnackbar({ snackbarOpen: true, snackbarMessage: err?.message, snackbarState: "error" }));
              }
            }}
            className={`flex-shrink-0 flex items-center gap-1.5 bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-50 transition-colors ${interClass} whitespace-nowrap`}
          >
            <Img
              className="h-4 w-4"
              src="/images/img_share-red.svg"
              alt="share icon"
            />
            {t("resendLink")}
          </button>
        </div>
      ) : null}

      {/* ── Recipient confirmed – prompt sender to place order ───────────── */}
      {orderData?.recipientStatus == "accepted" &&
      orderData?.status == "pending" ? (
        <div className="flex items-center justify-between gap-4 bg-red-50 border border-red-100 rounded-lg px-4 py-3 mb-4 mt-4">
          <div className="flex items-start gap-3 flex-1">
            <svg
              className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <p className={`text-sm text-gray-800 leading-relaxed ${interClass}`}>
              <span className="font-semibold text-gray-900">Please Note: </span>
              {t("yourRecipientHasConfirmedTheDetailsToConfirmThe_text")}{" "}
              {t("You have")}{" "}
              <span className="font-semibold text-red-700">30 Minutes</span>{" "}
              {t("to confirm this order otherwise it will be cancelled.")}
            </p>
          </div>
          <button
            onClick={() => setIsGiftPayment(true)}
            className={`flex-shrink-0 bg-[white] border border-gray-300 rounded-full px-4 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-50 transition-colors ${interClass} whitespace-nowrap`}
          >
            {t("placeOrder2")}
          </button>
        </div>
      ) : null}

      {/* <ShareRedBox orderData={orderData} /> */}
    </>
  );
};

export default OrderDetailGift;